import { ANALYTICS_EVENTS, trackEvent } from "utils/analytics";

export type OnboardingTourSource = "auto" | "help-button";

export const trackOnboardingStarted = (source: OnboardingTourSource): void => {
  trackEvent(ANALYTICS_EVENTS.ONBOARDING_STARTED, { source });
};

export const trackOnboardingStepViewed = (
  stepIndex: number,
  stepId: string,
): void => {
  trackEvent(ANALYTICS_EVENTS.ONBOARDING_STEP_VIEWED, { stepIndex, stepId });
};

export const trackOnboardingCompleted = (totalSteps: number): void => {
  trackEvent(ANALYTICS_EVENTS.ONBOARDING_COMPLETED, { totalSteps });
};

export const trackOnboardingSkipped = (stepIndex: number): void => {
  trackEvent(ANALYTICS_EVENTS.ONBOARDING_SKIPPED, { stepIndex });
};
